import * as React from 'react';
import { Canceler } from 'axios';

import { IOption } from 'src/components/Form/Select';

import API from 'src/services/api';
import { MarketContext } from 'src/services/contexts/markets/MarketContext';
import { Select, Button } from 'src/components';

interface IDownloadFormState {
  marketId: number | null;
  templateId: number | null;
  loadingTemplates: boolean;
  downloadingFile: boolean;
  marketOptions: Array<IOption<number>>;
  templateOptions: Array<IOption<number>>;
}

export default class DownloadForm extends React.Component<
  {},
  IDownloadFormState
> {
  static contextType = MarketContext;
  context!: React.ContextType<typeof MarketContext>;
  reqCanceler: Canceler | null = null;

  state: IDownloadFormState = {
    marketId: null,
    templateId: null,
    loadingTemplates: false,
    downloadingFile: false,
    marketOptions: [],
    templateOptions: [],
  };

  async componentDidMount() {
    const markets = this.context.visibilityProfiles;

    const marketOptions = markets.map((market) => ({
      label: market.name,
      value: market.id,
    }));
    this.setState({
      marketOptions,
    });
  }
  componentWillUnmount() {
    if (this.reqCanceler) {
      this.reqCanceler();
    }
  }

  getTemplates = async (marketId: number) => {
    this.setState({
      loadingTemplates: true,
    });

    const { getData, cancel } = API.LINK_UPLOAD.getTemplates(marketId);
    this.reqCanceler = cancel;
    const templates = await getData();
    this.reqCanceler = null;

    const templateOptions = templates.map(
      (template: { name: string; id: number }) => ({
        label: template.name,
        value: template.id,
      })
    );
    this.setState({
      loadingTemplates: false,
      templateOptions,
    });
  };

  downloadTemplate = async () => {
    const { marketId, templateId } = this.state;
    if (!marketId || !templateId) {
      return;
    }
    this.setState({
      downloadingFile: true,
    });

    const { getData, cancel } = API.LINK_UPLOAD.downloadTemplate(
      marketId,
      templateId
    );
    this.reqCanceler = cancel;
    await getData();
    this.reqCanceler = null;

    this.setState({
      downloadingFile: false,
    });
  };

  onMarketChange = (choice: IOption<any>) => {
    const marketId = choice.value;
    this.setState({
      marketId,
    });
    this.getTemplates(marketId);
  };

  onTemplateChange = (choice: IOption<any>) => {
    this.setState({
      templateId: choice.value,
    });
  };

  render() {
    const {
      marketOptions,
      marketId,
      templateOptions,
      templateId,
      loadingTemplates,
    } = this.state;
    return (
      <form>
        <div className="flex mb-6">
          <label className="w-48 pt-2 pr-6" htmlFor="market">
            Choose a market*
          </label>
          <div className="flex-1">
            <div className="flex items-center">
              <Select
                className="flex-1"
                name="market"
                onChange={this.onMarketChange}
                options={marketOptions}
                isLoading={!marketOptions.length}
                isDisabled={!marketOptions.length}
              />
              {/* <TooltipIcon className="ml-4" width="w-64" text="Helping" /> */}
            </div>
          </div>
        </div>
        <div className="flex mb-6">
          <label className="w-48 pt-2 pr-6" htmlFor="template">
            Choose a template*
          </label>
          <div className="flex-1">
            <div className="flex items-center">
              <Select
                className="flex-1"
                name="template"
                onChange={this.onTemplateChange}
                options={templateOptions}
                isLoading={loadingTemplates}
                isDisabled={!marketId || loadingTemplates}
              />
              {/* <TooltipIcon className="ml-4" width="w-64" text="Helping" /> */}
            </div>
          </div>
        </div>
        <Button
          className="ml-48"
          disabled={!marketId || !templateId}
          onClick={this.downloadTemplate}
          loading={this.state.downloadingFile}
          loadingLabel="Downloading template"
        >
          Download template
        </Button>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/LinkCreateBulkExcel/components/DownloadForm.tsx